document.addEventListener('DOMContentLoaded', function() {
  const popup = document.querySelector('.section-notification-popup');
  const popupWrap = popup.querySelector('.notification-block');
  const closeButton = document.querySelector('.notification-close-popup');
  const maxShowTimes = parseInt(popupWrap.getAttribute('data-show-notifications'), 10);
  let closeCount = sessionStorage.getItem('popupCloseCount') || 0;

  function showPopup() {
    popup.classList.remove('popup-hidden');
  }

  function hidePopup() {
    popup.classList.add('popup-hidden');
    closeCount++;
    sessionStorage.setItem('popupCloseCount', closeCount);
  }

  if (closeCount < maxShowTimes) {
    setTimeout(showPopup, 5000);
  }

  closeButton.addEventListener('click', hidePopup);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      hidePopup();
    }
  });
});

/* VARINIS notification opens promo popup */
document.addEventListener('DOMContentLoaded', function () {
  const notification = document.querySelector('.section-notification-popup .notification-block');
  const closeButton = document.querySelector('.section-notification-popup .notification-close-popup');
  const promoPopup = document.querySelector('.promo-popup-wrap');
  const promoOverlay = promoPopup ? promoPopup.querySelector('.overlay') : null;

  if (!notification || !promoPopup) return;

  notification.style.cursor = 'pointer';
  notification.setAttribute('role', 'button');
  notification.setAttribute('tabindex', '0');
  notification.setAttribute('aria-label', 'Gauk 10 procentų nuolaidą');

  function openPromoPopup() {
    promoPopup.style.visibility = 'visible';
    promoPopup.style.opacity = '1';
    if (promoOverlay) promoOverlay.classList.remove('hidden');
  }

  notification.addEventListener('click', function (event) {
    if (event.target.closest('.notification-close-popup')) return;
    openPromoPopup();
  });

  notification.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openPromoPopup();
    }
  });

  if (closeButton) {
    closeButton.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }
});
